import {i18n} from "@/plugins/i18n";

export const walletCustomWageStatus = {
    ENABLED: 1,
    DISABLED: 2,
};

export const walletCustomWageStatusStr = {
    ENABLED: i18n.t('label.active'),
    DISABLED: i18n.t('label.inactive'),

    get(status) {
        let status_str = null;

        Object.keys(walletCustomWageStatus).forEach(item => {
            if (walletCustomWageStatus[item] === status) {
                status_str = walletCustomWageStatusStr[item];
            }
        });

        return status_str;
    }
};
